/* Native dialog, on-demand full-size photos; original image links work without JS. */
(function () {
  'use strict';
  var dialog = document.querySelector('[data-photo-dialog]');
  var links = Array.from(document.querySelectorAll('[data-photo-link]'));
  if (!dialog || !dialog.showModal || !links.length) return;
  var image = dialog.querySelector('[data-photo-image]');
  var stage = dialog.querySelector('[data-photo-stage]');
  var zoom = dialog.querySelector('[data-photo-zoom]');
  var count = dialog.querySelector('[data-photo-count]');
  var index = 0, trigger, overflow;
  function fit() {
    stage.classList.remove('is-zoomed');
    zoom.textContent = dialog.dataset.zoomLabel;
    zoom.setAttribute('aria-pressed', 'false');
    stage.scrollTo(0, 0);
  }
  function show(next) {
    index = (next + links.length) % links.length;
    fit();
    image.src = links[index].href;
    image.alt = links[index].querySelector('img').alt;
    count.textContent = dialog.dataset.countLabel.replace('__CURRENT__', index + 1).replace('__TOTAL__', links.length);
    zoom.disabled = true;
  }
  image.addEventListener('load', function () {
    image.style.setProperty('--photo-width', image.naturalWidth + 'px');
    zoom.disabled = image.naturalWidth <= stage.clientWidth && image.naturalHeight <= stage.clientHeight;
  });
  image.addEventListener('error', function () { zoom.disabled = true; });
  links.forEach(function (link, i) {
    link.addEventListener('click', function (event) {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault(); trigger = link; overflow = document.body.style.overflow;
      show(i); dialog.showModal(); document.body.style.overflow = 'hidden';
      dialog.querySelector('[data-photo-close]').focus();
    });
  });
  dialog.querySelector('[data-photo-close]').addEventListener('click', function () { dialog.close(); });
  dialog.querySelector('[data-photo-prev]').addEventListener('click', function () { show(index - 1); });
  dialog.querySelector('[data-photo-next]').addEventListener('click', function () { show(index + 1); });
  dialog.querySelectorAll('[data-photo-prev], [data-photo-next]').forEach(function (button) { button.hidden = links.length < 2; });
  zoom.setAttribute('aria-pressed', 'false');
  zoom.addEventListener('click', function () {
    if (stage.classList.contains('is-zoomed')) fit();
    else { stage.classList.add('is-zoomed'); zoom.textContent = dialog.dataset.fitLabel; zoom.setAttribute('aria-pressed', 'true'); stage.focus(); stage.scrollTo((stage.scrollWidth-stage.clientWidth)/2, (stage.scrollHeight-stage.clientHeight)/2); }
  });
  dialog.addEventListener('keydown', function (event) {
    if (stage.classList.contains('is-zoomed')) return;
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1)); }
  });
  dialog.addEventListener('click', function (event) {
    var box = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
  });
  dialog.addEventListener('close', function () {
    document.body.style.overflow = overflow || ''; fit();
    if (trigger && trigger.isConnected) trigger.focus({ preventScroll: true });
  });
})();
